<template>
  <div class="orderBanner" v-if="activityList.length>0">
    <el-carousel   indicator-position="none" :interval="4000" :arrow="activityList.length<=1?'never':''">
      <el-carousel-item v-for="item in activityList" :key="item.id">
        <div @click="trunUrl(item)" class="itemUrl" id="itemUrl">
          <!-- :href="item.imgLinkUrl+'?ad='+item.id" -->
          <a v-if="item.imgLinkUrl" class="hot-activity-link" >
            <img :src="`${previewstatic}?code=${item.attachment}`" alt="" />
          </a>
          <span v-else class="hot-activity-link" >
            <img :src="`${previewstatic}?code=${item.attachment}`" alt="" />
          </span>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { getListByType,insertAdvertisingEffect,insertAdvertisingClick,updateAdvertisingClick} from '@/utils/api/dashboard';
import { previewstatic } from '@/utils/config';
import {openWindow} from "@/utils/common";
export default {
  data(){
    return{
      activityList:[],
      previewstatic,
    }
  },
  computed:{
  },
  methods:{
    getactivityList(){
      let params= {"advertisingType":37}
      getListByType(params).then(res=>{
        if(res.rspResult.bizCode==200){
          this.activityList=res.rspListData.list
          // 曝光量
          this.activityList.forEach((item, index) => {
              const params = {
                advertisingId: item.id,
                lengthStay: 0,
              };
              // console.log(params)
              insertAdvertisingEffect(params);//曝光量
            });
        }
      })
    },
    // 点击量
    trunUrl(item){
      const params = {
        advertisingId: item.id,
      };
      insertAdvertisingClick(params).then((res) => {
       let adId2 = res ? window.btoa(res.data.id) : "";
       openWindow(item.imgLinkUrl, adId2);
      });
    }, 
  },
  mounted(){
    this.getactivityList()
  },
}
</script>
<style lang="scss" scoped>

.itemUrl{
  height: 100%;
}
.hot-activity {
  background: #fff;
  padding: 20px;
  box-shadow: 0 1px 6px 0 #001e3b12;
  
  &-link {
    display: block;
    width: 100%;
    height: 100%;
    // border-radius: 4px;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 100%;
      // object-fit: contain;
    }
  }

}
</style>
<style lang="scss">
.orderBanner{
  margin-bottom: 12px;
  .el-carousel__container{
    height: 142px !important;
  } 
}
</style>